import '../styles/main.scss'

import initSmoothScrolling from './helpers/smooth-scrolling'

import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus'

Alpine.plugin(collapse)
Alpine.plugin(focus)

window.Alpine = Alpine
 
Alpine.start()

initSmoothScrolling()
